import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';

const subPropIsEqual = (prev, next, prop, subProp) =>
  prev[prop] && next[prop]
    ? prev[prop][subProp] === next[prop][subProp]
    : !prev[prop] === !next[prop];

class CategoryRank extends React.Component {
  shouldComponentUpdate(nextProps) {
    const propsAreEqual =
      this.props.name === nextProps.name &&
      subPropIsEqual(this.props, nextProps, 'category', 'name') &&
      subPropIsEqual(this.props, nextProps, 'category', 'pathName') &&
      subPropIsEqual(this.props, nextProps, 'popularity', 'inCategory') &&
      subPropIsEqual(this.props, nextProps, 'userReviewSummary', 'rating');
    return !propsAreEqual;
  }

  render() {
    const { name, category, popularity, userReviewSummary } = this.props;
    const { t } = this.context;
    return category &&
      popularity &&
      popularity.inCategory > 0 &&
      popularity.inCategory < 100 ? (
      <T
        domain="product"
        product={name}
        category={
          <Link key={category.id} to={category.pathName}>
            {category.name}
          </Link>
        }
        rating={
          userReviewSummary && userReviewSummary.rating
            ? t('product', 'product-info.rank-rating', {
                rating: Number(userReviewSummary.rating).toFixed(1),
              })
            : ''
        }
        n={popularity.inCategory}
      >
        {`product-info.rank${popularity.inCategory <= 10 ? '-popular' : ''}`}
      </T>
    ) : null;
  }
}

const { string, number, shape } = PropTypes;

CategoryRank.contextType = AppContext;

CategoryRank.propTypes = {
  name: string,
  category: shape({
    name: string,
    pathName: string,
  }),
  popularity: shape({
    inCategory: number,
  }),
  userReviewSummary: shape({
    rating: number,
  }),
};

CategoryRank.defaultProps = {
  name: undefined,
  category: undefined,
  popularity: undefined,
  userReviewSummary: undefined,
};

export default CategoryRank;
